// 获取平台列表
import {http} from "../util/http"
import headers from "./employeeSystemHeader"
import {API_KOTLIN_DOMAIN} from "../config"

export const fetchPlatformList = (params) => {
    return http({
        headers: headers(),
        url: `${API_KOTLIN_DOMAIN}/table/groupon/platform`,
        params,
    })
}


// WEBPACK FOOTER //
// ./src/api/platformSetting.js